// Generated file : do not modify

import Route from '@/extend/classes/Route';
import { ListFilter } from '@/extend/classes/ListData';
import { Fiches } from '@/generated/classes/AppSchema';
import Dialog from '@/generated/classes/Dialog';
import { Alerts } from '@/framework/base/helpers/Alerts';
import { 
  storeSubscription,
  storeUser,
  storeManualBillingDocument,
  storeTransaction,
  storeDelivery,
  storeSupport,
  storeDocument,
  storeContrat,
  storePaie,
  storeNotif,
  storeContact,
  storeProjet,
  storeSalarie,
  storeEtablissement,
  storeAttestation,
  storeObjetMetier,
} from '@/generated/stores';

export class NotifWatcher {
  public static fct: (value: Route, dialog: Dialog) => void;
  public setWatcher (fct: (value: Route, dialog: Dialog) => void) {
    NotifWatcher.fct = fct;
  }
  public getWatcher (): (value: Route, dialog: Dialog) => void {
    return NotifWatcher.fct;
  }
}

export class RouteBuilder {
  private static currentRoute: Route = new Route();

  // eslint-disable-next-line
  public static getRouteParams (route: Route): Record<string, any> {
    const ficheObj = this.getRouteObj(route);
    const params = { module: route.module, type: route.fiche, id: route.ficheObjId, ficheObj: ficheObj}
    const routeParams = { name: route.module.toLowerCase(), hash: '', params: params };
    return routeParams;
  }

  public static setRoute (route: Route): void {
    RouteBuilder.currentRoute = route;
  }

  public static sameRoute (route: Route): boolean {
    return RouteBuilder.currentRoute.module == route.module &&
      RouteBuilder.currentRoute.fiche == route.fiche &&
      RouteBuilder.currentRoute.ficheObjId == route.ficheObjId;
  }
  // eslint-disable-next-line
  public static getRouteObj (route: Route): any | null {
    return this.getFicheObj(route);
  }

  // eslint-disable-next-line
  public static getFicheObj (route: Route): any | null {
    if (route.fiche == Fiches.ABONNEMENT_LIST && route.ficheObjId != null) {
      return storeSubscription.getSubscription(route.ficheObjId);
    }
    else if (route.fiche == Fiches.SUBSCRIPTION && route.ficheObjId != null) {
      return storeSubscription.getSubscription(route.ficheObjId);
    }
    else if (route.fiche == Fiches.POINTAGES && route.ficheObjId != null) {
      return storeUser.getUser(route.ficheObjId);
    }
    else if (route.fiche == Fiches.MANUAL_BILLING_DOCUMENTS && route.ficheObjId != null) {
      return storeManualBillingDocument.getManualBillingDocument(route.ficheObjId);
    }
    else if (route.fiche == Fiches.MANUAL_BILLING_DOCUMENT && route.ficheObjId != null) {
      return storeManualBillingDocument.getManualBillingDocument(route.ficheObjId);
    }
    else if (route.fiche == Fiches.CHECKS_RECU && route.ficheObjId != null) {
      return storeTransaction.getTransaction(route.ficheObjId);
    }
    else if (route.fiche == Fiches.CHECKS_EMIS && route.ficheObjId != null) {
      return storeTransaction.getTransaction(route.ficheObjId);
    }
    else if (route.fiche == Fiches.PRELEVEMENT_EMIS && route.ficheObjId != null) {
      return storeDelivery.getDelivery(route.ficheObjId);
    }
    else if (route.fiche == Fiches.CARTE_EMIS && route.ficheObjId != null) {
      return storeTransaction.getTransaction(route.ficheObjId);
    }
    else if (route.fiche == Fiches.VIREMENTS_RECU && route.ficheObjId != null) {
      return storeTransaction.getTransaction(route.ficheObjId);
    }
    else if (route.fiche == Fiches.VIREMENTS_EMIS && route.ficheObjId != null) {
      return storeDelivery.getDelivery(route.ficheObjId);
    }
    else if (route.fiche == Fiches.CREDIT_LIMITS && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.VIREMENT_SALARIE && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.VIREMENT_ETABLISSEMENT && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.RAPPROCHEMENT && route.ficheObjId != null) {
      return storeTransaction.getTransaction(route.ficheObjId);
    }
    else if (route.fiche == Fiches.DOCUMENT_LIST && route.ficheObjId != null) {
      return storeDocument.getDocument(route.ficheObjId);
    }
    else if (route.fiche == Fiches.DOCUMENT_VIEWER && route.ficheObjId != null) {
      return storeDocument.getDocument(route.ficheObjId);
    }
    else if (route.fiche == Fiches.CONTRAT_VIEWER && route.ficheObjId != null) {
      return storeContrat.getContrat(route.ficheObjId);
    }
    else if (route.fiche == Fiches.PAIE_VIEWER && route.ficheObjId != null) {
      return storePaie.getPaie(route.ficheObjId);
    }
    else if (route.fiche == Fiches.NOTIFICATION && route.ficheObjId != null) {
      return storeNotif.getNotif(route.ficheObjId);
    }
    else if (route.fiche == Fiches.PREFERENCE && route.ficheObjId != null) {
      return storeContact.getContact(route.ficheObjId);
    }
    else if (route.fiche == Fiches.PROFIL && route.ficheObjId != null) {
      return storeContact.getContact(route.ficheObjId);
    }
    else if (route.fiche == Fiches.PROJET_LIST && route.ficheObjId != null) {
      return storeProjet.getProjet(route.ficheObjId);
    }
    else if (route.fiche == Fiches.PROJET_CONTRATS && route.ficheObjId != null) {
      return storeContrat.getContrat(route.ficheObjId);
    }
    else if (route.fiche == Fiches.PROJET && route.ficheObjId != null) {
      return storeProjet.getProjet(route.ficheObjId);
    }
    else if (route.fiche == Fiches.CONTRAT && route.ficheObjId != null) {
      return storeContrat.getContrat(route.ficheObjId);
    }
    else if (route.fiche == Fiches.PAIE && route.ficheObjId != null) {
      return storePaie.getPaie(route.ficheObjId);
    }
    else if (route.fiche == Fiches.SALARIE_LIST && route.ficheObjId != null) {
      return storeSalarie.getSalarie(route.ficheObjId);
    }
    else if (route.fiche == Fiches.SALARIE_ABSTRACT && route.ficheObjId != null) {
      return storeSalarie.getSalarie(route.ficheObjId);
    }
    else if (route.fiche == Fiches.SALARIE && route.ficheObjId != null) {
      return storeSalarie.getSalarie(route.ficheObjId);
    }
    else if (route.fiche == Fiches.ETABLISSEMENT_LIST && route.ficheObjId != null) {
      return storeEtablissement.getEtablissement(route.ficheObjId);
    }
    else if (route.fiche == Fiches.ETABLISSEMENT_ABSTRACT && route.ficheObjId != null) {
      return storeEtablissement.getEtablissement(route.ficheObjId);
    }
    else if (route.fiche == Fiches.ETABLISSEMENT && route.ficheObjId != null) {
      return storeEtablissement.getEtablissement(route.ficheObjId);
    }
    else if (route.fiche == Fiches.TEST_PAIES && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.TRANSACTION_CAISSE && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.TRANSACTION_SALARIE && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.TRANSACTION_ETABLISSEMENT && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.VERSEMENT_EMPLOYEUR && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.GESTION_AEM && route.ficheObjId != null) {
      return storeSupport.getSupport(route.ficheObjId);
    }
    else if (route.fiche == Fiches.ATTESTATION_COMPTE && route.ficheObjId != null) {
      return storeAttestation.getAttestation(route.ficheObjId);
    }
    else if (route.fiche == Fiches.OBJET_METIER && route.ficheObjId != null) {
      return storeObjetMetier.getObjetMetier(route.ficheObjId);
    }
    return null;
  }

  public static loadStore (route: Route) {
    if (route) {
      if (route.fiche == Fiches.ABONNEMENT_LIST) {
        return storeSubscription.registerSubscription();
      }
      else if (route.fiche == Fiches.SUBSCRIPTION) {
        return storeSubscription.registerSubscription();
      }
      else if (route.fiche == Fiches.POINTAGES) {
        return storeUser.registerUser();
      }
      else if (route.fiche == Fiches.MANUAL_BILLING_DOCUMENTS) {
        return storeManualBillingDocument.registerManualBillingDocument();
      }
      else if (route.fiche == Fiches.MANUAL_BILLING_DOCUMENT) {
        return storeManualBillingDocument.registerManualBillingDocument();
      }
      else if (route.fiche == Fiches.CHECKS_RECU) {
        return storeTransaction.registerTransaction();
      }
      else if (route.fiche == Fiches.CHECKS_EMIS) {
        return storeTransaction.registerTransaction();
      }
      else if (route.fiche == Fiches.PRELEVEMENT_EMIS) {
        return storeDelivery.registerDelivery();
      }
      else if (route.fiche == Fiches.CARTE_EMIS) {
        return storeTransaction.registerTransaction();
      }
      else if (route.fiche == Fiches.VIREMENTS_RECU) {
        return storeTransaction.registerTransaction();
      }
      else if (route.fiche == Fiches.VIREMENTS_EMIS) {
        return storeDelivery.registerDelivery();
      }
      else if (route.fiche == Fiches.CREDIT_LIMITS) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.VIREMENT_SALARIE) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.VIREMENT_ETABLISSEMENT) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.RAPPROCHEMENT) {
        return storeTransaction.registerTransaction();
      }
      else if (route.fiche == Fiches.DOCUMENT_LIST) {
        return storeDocument.registerDocument();
      }
      else if (route.fiche == Fiches.DOCUMENT_VIEWER) {
        return storeDocument.registerDocument();
      }
      else if (route.fiche == Fiches.CONTRAT_VIEWER) {
        return storeContrat.registerContrat();
      }
      else if (route.fiche == Fiches.PAIE_VIEWER) {
        return storePaie.registerPaie();
      }
      else if (route.fiche == Fiches.NOTIFICATION) {
        return storeNotif.registerNotif();
      }
      else if (route.fiche == Fiches.PREFERENCE) {
        return storeContact.registerContact();
      }
      else if (route.fiche == Fiches.PROFIL) {
        return storeContact.registerContact();
      }
      else if (route.fiche == Fiches.PROJET_LIST) {
        return storeProjet.registerProjet();
      }
      else if (route.fiche == Fiches.PROJET_CONTRATS) {
        return storeContrat.registerContrat();
      }
      else if (route.fiche == Fiches.PROJET) {
        return storeProjet.registerProjet();
      }
      else if (route.fiche == Fiches.CONTRAT) {
        return storeContrat.registerContrat();
      }
      else if (route.fiche == Fiches.PAIE) {
        return storePaie.registerPaie();
      }
      else if (route.fiche == Fiches.SALARIE_LIST) {
        return storeSalarie.registerSalarie();
      }
      else if (route.fiche == Fiches.SALARIE_ABSTRACT) {
        return storeSalarie.registerSalarie();
      }
      else if (route.fiche == Fiches.SALARIE) {
        return storeSalarie.registerSalarie();
      }
      else if (route.fiche == Fiches.ETABLISSEMENT_LIST) {
        return storeEtablissement.registerEtablissement();
      }
      else if (route.fiche == Fiches.ETABLISSEMENT_ABSTRACT) {
        return storeEtablissement.registerEtablissement();
      }
      else if (route.fiche == Fiches.ETABLISSEMENT) {
        return storeEtablissement.registerEtablissement();
      }
      else if (route.fiche == Fiches.TEST_PAIES) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.TRANSACTION_CAISSE) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.TRANSACTION_SALARIE) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.TRANSACTION_ETABLISSEMENT) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.VERSEMENT_EMPLOYEUR) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.GESTION_AEM) {
        return storeSupport.registerSupport();
      }
      else if (route.fiche == Fiches.ATTESTATION_COMPTE) {
        return storeAttestation.registerAttestation();
      }
      else if (route.fiche == Fiches.OBJET_METIER) {
        return storeObjetMetier.registerObjetMetier();
      }
    } else {
      Alerts.debug("LoadStore: Route not defined")
    }
  }
}
